/* sl-img-fade.js: lazy photos fade in (CSS hides only img.sl-imgf, which only this adds and removes); PDP boxes get slm-in once */
(function(){
var w=window,d=document,O=w.IntersectionObserver;
if(!O||!Element.prototype.closest||w.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
var H='sl-imgf',
SKIP='.sl-hero,.sl-header,.sl-footer,.sl-gallery__main,.sl-lightbox,[data-sl-cart-drawer],.sl-buyzone,.sl-buycard,#SlBuyForm,[data-sl-addon],.sl-stickybuy,form.sl-cart';
function each(l,f){for(var i=0;i<l.length;i++)f(l[i])}
var io=new O(function(es){each(es,function(e){var m=e.target;if(e.isIntersecting){io.unobserve(m);m._slfT=setTimeout(function(){show(m)},2500)}})});
var bo=new O(function(es){each(es,function(e){if(e.isIntersecting){bo.unobserve(e.target);e.target.classList.add('slm-in')}})},{rootMargin:'0px 0px -12%'});
function show(m,f){
if(!m._slf)return;
m._slf=0;clearTimeout(m._slfT);io.unobserve(m);
m.classList.remove(H);
if(f){m.classList.add(H+'-in');setTimeout(function(){m.classList.remove(H+'-in')},700)}
}
function onL(){show(this,1)}
function onE(){show(this)}
function tag(m){
if(m._slf)return;
if(m.classList.contains(H))m.classList.remove(H);
if(m.complete||m.naturalWidth||m.loading!=='lazy'||/high/i.test(m.getAttribute('fetchpriority'))||m.closest(SKIP))return;
m._slf=1;
m.addEventListener('load',onL);m.addEventListener('error',onE);
m.classList.add(H);io.observe(m);
}
function scan(n){
if(n.nodeName==='IMG')return tag(n);
each(n.querySelectorAll('img[loading]'),tag);
}
function start(){
scan(d);
each(d.querySelectorAll('.sl-keyfacts>li,.sl-pdp-reviews .sl-reviews__grid>.sl-review'),function(b){bo.observe(b)});
if(w.MutationObserver)new MutationObserver(function(rs){each(rs,function(r){each(r.addedNodes,function(n){if(n.nodeType===1)scan(n)})})}).observe(d.documentElement,{childList:true,subtree:true});
}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',start);else start();
})();
